import {
  VuexModule,
  Module,
  Action,
  Mutation,
  getModule
} from 'vuex-module-decorators'
import store from '@/store/index'
import { SappState } from '@/store/getters'
import { Message } from '@lui/lui-ui'
import routeData from '@/router/nav.config'
import API from '@/api'
import Utils from '@/utils/utils'
import Cookies from 'js-cookie'
import i18n from '@/i18n'

@Module({ dynamic: true, store, name: 'sapp' })
class Sapp extends VuexModule implements SappState {
  public sidebar = {
    opened: false,
    showSidebar: false,
    showToolTip: true // 是否开启文本省略提示
  }

  public editableTabsValue = '/'

  public homePage = {
    title: i18n.t('homePage'),
    name: 'home',
    content: '/index/index',
    path: '/'
  }

  public butsPermission: string[] = []

  public editableTabs:any[] = [this.homePage]

  // 缓存页面的最大数，超过则把缓存最久切没有被访问的销毁
  public maxPageNumber = 10

  // 显隐顶导及菜单
  public showCommonView = false

  // 主题色
  public themeColor = 'blue'

  public menus: any = []

  public plMenus: any = []
  public oceanMenus: any = []

  // 侧边栏是否以二级子菜单的形式展示
  public isSubMenus: boolean = false

  // 是否显示tab 默认显示
  public showTab = true

  // 用于tab页面刷新
  public isRouterAlive = true

  // 允许keepALive缓存的页面
  public keepAliveComponents: string[] = []

  // 左侧菜单当前展示
  public currentActiveMenuIndex = 0

  // 顶部导航栏当前选中态
  public topMenuActiveIndex: number = -1

  // 收藏菜单
  public favouriteMenu: MenuItem[] = localStorage.getItem('favouriteMenu') ? JSON.parse(localStorage.getItem('favouriteMenu') || '') : []

  // 默认状态管理模式初始化为英文，用于动态变更网页展示语言
  public language: String = Cookies.get('language') || 'en_US'

  public get currentTab() {
    return this.editableTabs.find((tab) => tab.path === this.editableTabsValue)
  }

  @Mutation
  public SET_TOP_MENU_ACTIVE_INDEX(index: number) {
    this.topMenuActiveIndex = index
  }

  @Mutation
  public SET_BUTS_PERMISSION(permissionCode: string) {
    this.butsPermission.push(permissionCode)
  }

  @Mutation
  public SET_CURRENT_ACTIVE_MENU_INDEX(index: number) {
    this.currentActiveMenuIndex = index
  }

  @Mutation
  public SET_THRME_COLOR(color: string) {
    this.themeColor = color
  }

  @Mutation
  public TOGGLE_ROUTER_ALIVE() {
    this.isRouterAlive = !this.isRouterAlive
  }

  @Mutation
  public INIT_FRAMEWORK() {
    this.showCommonView = JSON.parse(
      Utils.queryUrl(window.location.href).showCommonView || 1
    )
    this.sidebar.showSidebar = this.showCommonView
  }

  @Mutation
  public KEEP_ALIVE(componentName: string) {
    if (!this.keepAliveComponents.includes(componentName)) {
      this.keepAliveComponents.push(componentName)
    }
  }

  @Mutation
  public CANCEL_KEEP_ALIVE(componentName: string) {
    const index = this.keepAliveComponents.indexOf(componentName)
    index !== -1 && this.keepAliveComponents.splice(index, 1)
  }

  @Mutation
  public SET_KEEP_ALIVE(aliveArr: string[] = []) {
    this.keepAliveComponents = aliveArr
  }

  @Mutation
  private SET_MENUS(menus: any) {
    this.menus = menus
  }

  @Mutation
  private SET_OCEAN_MENUS(oceanMenus: any) {
    this.oceanMenus = oceanMenus
  }
  @Mutation
  private SET_PL_MENUS(plMenus: any) {
    this.plMenus = plMenus
  }

  @Mutation
  public SHOW_SIDEBAR() {
    this.sidebar.showSidebar = true
  }

  @Mutation
  public SHOW_SIDEBAR_OPENED() {
    this.sidebar.opened = true
  }

  @Mutation
  private HIDE_SIDEBAR() {
    this.sidebar.showSidebar = false
  }

  @Mutation
  private SET_EDITABLETABSVALUE(editableTabsValue: string) {
    this.editableTabsValue = editableTabsValue
  }

  @Mutation
  private REPLACE_EDITABLETABS(obj: any) {
    let showId:string| null = ''
    try {
      const match = obj.editableTabItem.fullPath.match(/[?&]showId=([^&]*)/)
      showId = match ? decodeURIComponent(match[1]) : null
    } catch (error) {
      console.log('当前单号error', error)
    }
    obj.editableTabItem.showId = showId
    if (JSON.stringify(this.editableTabs[obj.index].query) !== JSON.stringify(obj.editableTabItem.query)) {
      obj.editableTabItem.title = this.editableTabs[obj.index].title
      this.editableTabs[obj.index] = obj.editableTabItem
    }
  }
  @Mutation
  private SET_EDITABLETABS(editableTabItem: any) {
    let showId:string| null = ''
    try {
      const match = editableTabItem.fullPath.match(/[?&]showId=([^&]*)/)
      showId = match ? decodeURIComponent(match[1]) : null
    } catch (error) {
      console.log('当前单号error', error)
    }
    editableTabItem.showId = showId
    this.editableTabs.push(editableTabItem)
  }

  @Mutation
  private DEL_EDITABLETAB(tabIndex: number) {
    this.editableTabs.splice(tabIndex, 1)
  }

  @Mutation
  private SET_EDITABLE_TABS(newTabs: any) {
    this.editableTabs = newTabs
  }

  @Mutation
  private CHANGE_LANGUAGE(language: String) {
    this.language = language
    Cookies.set('language', language, { domain: '.jd.com', expires: 7 }) // 每次切换语言，存入cookie，防止刷新丢失
    Cookies.set('language', language) // 每次切换语言，存入cookie，防止刷新丢失
  }

  @Action
  public changeLanguage(lang: String) {
    this.CHANGE_LANGUAGE(lang)
  }

  @Action
  private SET_ASYNC_MENUSE({ routers = [], topIndex = 0 }) {
    // 重新设置Menu参数
    routers.forEach((route: any) => {
      const {
        name = '',
        text = '',
        icon = '',
        hrefType = '',
        meta = {}
      } = route
      route.meta = {
        title: name,
        icon,
        id: route.id,
        topIndex,
        ...meta
      }
      route.type = +hrefType
      if (route.children instanceof Array) {
        // 非叶子节点
        this.SET_ASYNC_MENUSE({ routers: route.children, topIndex })
      } else {
        route.children = []
        // 叶子节点，使用资源码最后一位进行路径命名
        route.path = route.path.split('-').pop()
      }
    })
    return routers
  }

  @Action({ rawError: true })
  public async getMenus(next:any) {
    try {
      const commonRes:any = await API.getMenu()
      // 处理并封装好全部的menu 处理分三步
      // 1、删除掉3pl里权限相关的菜单
      // 2、给3pl和itms的路由分别加base path
      // 3、
      let dataObj: any = {}
      if (commonRes.data && commonRes.data.length && Array.isArray(commonRes.data[0].children)) {
        // TODO   查看iTMS使用了什么数据
        sessionStorage.setItem('getUserMenuListSessionStorage', JSON.stringify(commonRes))
        commonRes.data[0].children.forEach((item: any) => {
          if (item.code === 'DISTRIBUTION-PLATFORM') {
            dataObj = item
          }
        })
      }
      // 3pl菜单特殊处理逻辑
      dataObj && dataObj.children && dataObj.children.forEach((item: any, index: number) => {
        if (item.code === '3PL-platform') {
          item.children.forEach((node: any, i: number) => {
            if (node.code === 'ServiceProviderMasterData' || node.code === 'PL-BiddingManage') {
              node.children.forEach((m: any, n: number) => {
                if (['PL-ServiceSupplier', 'PL-ScatterFilings'].includes(m.code)) {
                  dataObj.children[index].children[i].children[n].children = null
                }
              })
            }
          })
        }
      })
      const modifyUrls = (arr: any, index: number, hasIcon?: string) => {
        const butsIndex: number[] = []
        arr.forEach((item: any, index: number) => {
          if (item.type !== 0) {
            butsIndex.push(index)
            this.SET_BUTS_PERMISSION(item.code)
          } else {
            // 修改当前项的 url
            item.url = item.url ? '/st-itms' + item.url : null
            if (this.editableTabsValue === item.url) {
              this.SET_TOP_MENU_ACTIVE_INDEX(index)
            }
            if (hasIcon) {
              item.iconCode = item.code
            }
            // 如果有 children，递归调用
            if (item.children && item.children.length > 0) {
              if (item.code === 'ITMS-TransportationManage' || item.code === 'iTMS-OceanFreightBooking') {
                modifyUrls(item.children, index, 'hasIcon')
              } else {
                modifyUrls(item.children, index)
              }
            }
          }
        })
        butsIndex.reverse()
        butsIndex.forEach(inde => {
          arr.splice(inde, 1)
        })
      }
      const modify3plUrls = (arr: any, index: number, hasIcon?: string) => {
        const butsIndex: number[] = []
        arr.forEach((item: any, index: number) => {
          if (item.type !== 0) {
            butsIndex.push(index)
            this.SET_BUTS_PERMISSION(item.code)
          } else {
            // 修改当前项的 url
            if (item.url === '/trunkIine/report/index') {
              item.url = item.url ? '/st-itms' + item.url : null
            } else {
              item.url = item.url ? '/st-3pl' + item.url : null
            }
            if (this.editableTabsValue === item.url) {
              this.SET_TOP_MENU_ACTIVE_INDEX(index)
            }
            if (hasIcon) {
              item.iconCode = item.code
            }
            // 如果有 children，递归调用
            if (item.children && item.children.length > 0) {
              if (['3PL-platform', 'PrintingCenter', 'TrackingCenter', 'OperationalMonitoring', 'SystemTools'].includes(item.code)) {
                modify3plUrls(item.children, index, 'hasIcon')
              } else {
                modify3plUrls(item.children, index)
              }
            }
          }
        })
        butsIndex.reverse()
        butsIndex.forEach(inde => {
          arr.splice(inde, 1)
        })
      }
      const modifySiteUrls = (arr: any, index: number, hasIcon?: string) => {
        const butsIndex: number[] = []
        arr.forEach((item: any, index: number) => {
          if (item.type !== 0) {
            butsIndex.push(index)
            this.SET_BUTS_PERMISSION(item.code)
          } else {
            // 修改当前项的 url
            item.url = item.url ? '/st-site' + item.url : null
            if (this.editableTabsValue === item.url) {
              this.SET_TOP_MENU_ACTIVE_INDEX(index)
            }
            if (hasIcon) {
              item.iconCode = item.code
            }
            // 如果有 children，递归调用
            if (item.children && item.children.length > 0) {
              if (['DispatchManagement'].includes(item.code)) {
                modifySiteUrls(item.children, index, 'hasIcon')
              } else {
                modifySiteUrls(item.children, index)
              }
            }
          }
        })
        butsIndex.reverse()
        butsIndex.forEach(inde => {
          arr.splice(inde, 1)
        })
      }
      const modifyDmsUrls = (arr: any, index: number, hasIcon?: string) => {
        arr.forEach((item: any) => {
          if (item.type !== 0) {
            this.SET_BUTS_PERMISSION(item.code)
          } else {
            // 修改当前项的 url
            item.url = item.url ? '/st-dms' + item.url : null
            item.code = item.code.replace('iTMS-', '')
            if (this.editableTabsValue === item.url) {
              this.SET_TOP_MENU_ACTIVE_INDEX(index)
            }
            if (hasIcon) {
              item.iconCode = item.code
            }
            // 如果有 children，递归调用
            if (item.children && item.children.length > 0) {
              if (['LogisticsManagement'].includes(item.code)) {
                modifyDmsUrls(item.children, index, 'hasIcon')
              } else {
                modifyDmsUrls(item.children, index)
              }
            }
          }
        })
      }
      const plMenus = []
      for (let i = 0; i < dataObj.children.length; i++) {
        if (dataObj.children[i].code === 'ITMS-TransportationManage') {
          modifyUrls([dataObj.children[i]], i)
        } else if (dataObj.children[i].code === 'iTMS-OceanFreightBooking') {
          modifyUrls([dataObj.children[i]], i)
          this.SET_OCEAN_MENUS(dataObj.children[i])
        } else if (['3PL-platform', 'PrintingCenter', 'TrackingCenter', 'OperationalMonitoring', 'SystemTools'].includes(dataObj.children[i].code)) {
          modify3plUrls([dataObj.children[i]], i)
          plMenus.push(dataObj.children[i])
        } else if (dataObj.children[i].code === 'DispatchManagement') {
          modifySiteUrls([dataObj.children[i]], i)
        } else if (dataObj.children[i].code === 'LogisticsManagement') {
          modifyDmsUrls([dataObj.children[i]], i)
        }
      }
      // 此处需要计算当前高亮哪个菜单
      // this.SET_TOP_MENU_ACTIVE_INDEX(0)
      console.log('dataObj', dataObj)
      this.SET_MENUS(dataObj.children || [])
      this.SET_PL_MENUS(plMenus || [])
    } catch (error) {
      console.log(error)
      if (next) {
        next({
          path: '/noPermission'
        })
      }
    }
  }

  @Mutation
  private TOGGLE_SIDEBAR() {
    this.sidebar.opened = !this.sidebar.opened
  }

  // 切换收藏菜单
  @Mutation
  private TOGGLE_FAVOURITE_MENU(menu: MenuItem) {
    const index = this.favouriteMenu.findIndex((item) => item.id === menu.id)
    console.log('menumenumenumenu', menu)
    if (index === -1) {
      if (this.favouriteMenu.length >= 5) {
        Message.info('常用菜单最多只能保存5个')
        return
      }
      this.favouriteMenu.push(menu)
    } else {
      this.favouriteMenu.splice(index, 1)
    }
    // TODO: 需要实现存储常用菜单到库中
    localStorage.setItem('favouriteMenu', JSON.stringify(this.favouriteMenu))
  }

  @Action
  public toggleFavourite(item: MenuItem) {
    this.TOGGLE_FAVOURITE_MENU(item)
  }

  @Action
  public INIT_FAVOURITE_MENU() {
    // TODO: 需要实现从库中土读取藏用菜单
  }

  @Action
  public showSideBar() {
    this.SHOW_SIDEBAR()
  }

  @Action
  public showSideBarOpened() {
    this.SHOW_SIDEBAR()
    this.SHOW_SIDEBAR_OPENED()
  }

  @Action
  public hideSideBar() {
    this.HIDE_SIDEBAR()
  }

  @Action
  public toggleSideBar() {
    this.TOGGLE_SIDEBAR()
  }

  @Action
  public setEditableTabsValue(val: string) {
    this.SET_EDITABLETABSVALUE(val)
  }

  @Action
  private filterEditableTabs(tab: any) {
    let filterResIndex = -1
    this.editableTabs.forEach((item:any, index: number) => {
      if (tab.path === item.path) {
        filterResIndex = index
      }
    })
    return filterResIndex
  }

  @Action
  public async addTab(target: any) {
    target && this.SET_EDITABLETABSVALUE(target.path)
    const targetResIndex: any = await this.filterEditableTabs(target)
    if (targetResIndex < 0) {
      this.SET_EDITABLETABS(target)
    } else {
      this.REPLACE_EDITABLETABS({ editableTabItem: target, index: targetResIndex })
    }
  }

  @Action
  public setCurrentActiveMenuIndex(index: number) {
    this.SET_CURRENT_ACTIVE_MENU_INDEX(index)
  }

  @Action
  public setTopMenuActiveIndex(index: number) {
    console.log('in setTopMenuActiveIndex', index)
    this.SET_TOP_MENU_ACTIVE_INDEX(index)
  }

  @Action
  public removeTab(targetName: string) {
    let delIndex = -1
    console.log('delIndex22', this.editableTabsValue, targetName)
    if (this.editableTabsValue === targetName) {
      this.editableTabs.forEach((tab, index) => {
        if (tab.path === targetName) {
          delIndex = index
          const nextTab = this.editableTabs[index + 1] || this.editableTabs[index - 1]
          if (nextTab) {
            this.setEditableTabsValue(nextTab.path)
          }
        }
      })
    } else {
      this.editableTabs.filter((item, index) => {
        if (item.path === targetName) {
          delIndex = index
        }
        return delIndex
      })
    }
    console.log('delIndex', delIndex)
    // 取消缓存 TODO   取消子应用的缓存
    // this.CANCEL_KEEP_ALIVE(targetName)
    delIndex > 0 && this.DEL_EDITABLETAB(delIndex)
  }

  @Action
  public removeAllTab() {
    // 关闭所有tab
    this.SET_EDITABLE_TABS([this.homePage])
    this.setEditableTabsValue('/')
    // 取消缓存
    this.SET_KEEP_ALIVE()
  }

  @Action
  public removeAsideTab(data: any) {
    // 关闭某一边tab
    let newTabs: any = []
    const len: number = this.editableTabs.length
    const { index, dir } = data
    const oldName = this.editableTabs[index].name
    if (dir === 'right') {
      // 关闭右边
      newTabs = this.editableTabs.slice(0, index + 1)
    } else {
      // 关闭左边
      newTabs = this.editableTabs.slice(index, len)
    }
    if (newTabs.length === 0 || newTabs[0].name !== 'home') {
      newTabs.unshift(this.homePage)
    }
    this.setEditableTabsValue(oldName)
    this.SET_EDITABLE_TABS(newTabs)
    // 取消缓存
    this.SET_KEEP_ALIVE(newTabs.map((item: any) => item.name))
  }

  @Action
  public removeOtherTab(index: any) {
    // 关闭其他tab
    const oldName = this.editableTabs[index].name
    const newTabs: any = []
    newTabs.push(this.editableTabs[index])
    if (newTabs[0].name !== 'home') {
      newTabs.unshift(this.homePage)
    }
    this.setEditableTabsValue(oldName)
    this.SET_EDITABLE_TABS(newTabs)
    // 取消缓存
    this.SET_KEEP_ALIVE(newTabs.map((item: any) => item.name))
  }
}

export const SappModule = getModule(Sapp)
